import React from 'react';
import { Box, DetailsCardBody } from '@tq/ui-components';

import { ExpandableParagraph } from 'components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { BaseApplicationResponse } from 'types';

import { ApplicationStatusIndicator } from '../ApplicationStatusIndicator';
import { CaseDetailCardToggleProps } from './types/CaseDetailCardToggleProps';

export type ApplicationCardBodyProps = CaseDetailCardToggleProps & {
  relatedCase: BaseApplicationResponse;
  textExpanded?: boolean;
  showExpanded?: boolean;
};

export const ApplicationCardBody: React.FC<ApplicationCardBodyProps> = ({
  relatedCase,
  textExpanded,
  toggleClick,
  showExpanded = true,
}) => {
  const isMobile = useIsMobile();
  return (
    <DetailsCardBody>
      <Box mt={2}>
        {showExpanded ? (
          <ExpandableParagraph
            showButton={!isMobile}
            maxCharacters={{ base: 55, xs: 60, lg: 65 }}
            expanded={textExpanded}
            onExpanded={toggleClick}
          >
            {relatedCase.proposalText}
          </ExpandableParagraph>
        ) : (
          <Box whiteSpace='revert' fontSize='sm'>
            {relatedCase.proposalText}
          </Box>
        )}
      </Box>
      {isMobile && relatedCase?.applicationStatus && (
        <ApplicationStatusIndicator mt={2} status={relatedCase.applicationStatus} />
      )}
    </DetailsCardBody>
  );
};
